"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const icon_1 = __importDefault(require("../icon"));
const style_1 = require("./style");
const RotaButtonCircle = ({ onHandle, isDelete = false, styles, iconStyle }) => {
    const theme = (0, styled_components_1.useTheme)();
    const { AddIcon } = icon_1.default;
    const newStyle = Object.assign({ transform: isDelete ? "rotate(45deg)" : undefined }, iconStyle);
    return (react_1.default.createElement(style_1.StyledWrapButton, { style: Object.assign({}, styles), onClick: onHandle },
        react_1.default.createElement(AddIcon, { styles: newStyle, color: theme.white })));
};
exports.default = RotaButtonCircle;
